import EmployeeForm from '../EmployeeForm/EmployeeForm';
import axios from 'axios';
import { useEffect, useRef, useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoadingBtn from '../../../components/LoadingBtn/LoadingBtn';
import api from '../../../api/Api';

function EmployeeEdit() {
  const { identy } = useParams();
  const navigate = useNavigate();
  const [employee, setEmployee] = useState(null);
  const [loading, setLoading] = useState(false);
      const formRef = useRef();


  useEffect(() => {
    api.get(`/api/employees/${identy}`)
      .then((res) => setEmployee(res.data.response))
      .catch(err => console.error(err));
  }, [identy]);

  const handleEdit = (updatedEmployee) => {
    setLoading(true);
    api.put(`/api/employees/${identy}`, updatedEmployee)
    .then(() => {
         toast.success(" Employee Edit SuccessFully");
            setTimeout(() => navigate(`/employees/${identy}`), 1000);
          })
          .catch((err) => console.error(err))
          .finally(() => setLoading(false));
      };
    

if (!employee) return <p>Loading...</p>;

return (
  <>
      {/* <ToastContainer position="bottom-right" autoClose={3000} /> */}
    <div className='d-flex justify-content-between align-items-center mx-3'>
      <Link to={`/employees/${identy}`} className="btn btn-secondary my-3">← Back</Link>
      <h3 className='text-center mt-3'>Edit Employee</h3>
              <div>
          <LoadingBtn
            type="submit"
            text="Update"
            loading={loading}
            onClick={() => formRef.current.submitForm()}
          />
        </div>
    </div>
    <div className="container" style={{ width: "900px", height: '450px', overflowY: 'auto' }}>

      <EmployeeForm initialData={employee} onSubmit={handleEdit} ref={formRef}/>
    </div>

  </>
);
}
export default EmployeeEdit;
